import { Purpose } from "config/constants"
import { Guid } from "@/types"

export interface IGetOrderTypeDto {
    id: Guid
    purposeId: Purpose
    invoiceCode: string
    invoiceCodeDescription: string
    creditNoteCode: string
    creditNoteCodeDescription: string
    debitNoteCode?: string | null
    debitNoteCodeDescription?: string | null
    canInvoiceBeforeShipping?: boolean
}

export interface ICreateOrderTypeDto {
    purposeId: Purpose
    invoiceCode: string
    invoiceCodeDescription: string
    creditNoteCode: string
    creditNoteCodeDescription: string
    debitNoteCode?: string | null
    debitNoteCodeDescription?: string | null
}

export default class OrderType {
    id: Guid
    purposeId: Purpose
    invoiceCode: string
    invoiceCodeDescription: string
    creditNoteCode: string
    creditNoteCodeDescription: string
    debitNoteCode?: string
    debitNoteCodeDescription?: string
    canInvoiceBeforeShipping?: boolean

    constructor(dto: IGetOrderTypeDto) {
        this.id = dto.id
        this.purposeId = dto.purposeId
        this.invoiceCode = dto.invoiceCode
        this.invoiceCodeDescription = dto.invoiceCodeDescription
        this.creditNoteCode = dto.creditNoteCode
        this.creditNoteCodeDescription = dto.creditNoteCodeDescription
        this.debitNoteCode = dto.debitNoteCode ?? undefined
        this.debitNoteCodeDescription = dto.debitNoteCodeDescription ?? undefined
        this.canInvoiceBeforeShipping = dto.canInvoiceBeforeShipping
    }

    print() {
        return `${this.invoiceCodeDescription} (${this.invoiceCode})`
    }
}
